module.exports = __webpack_public_path__ + "assets/img/my-sub-bg.9a26fb07.png";